import Constant from '@/const';
import axios from 'axios';

const getOperationMarkingById = async idOM => {
  try {
    const response = await axios.get(
      Constant.apiUrl.concat(`/document/medical-treatment/${idOM}`),
    );
    return response.data.data;
  } catch (error) {
    this.showErrorAxios(error);
  }
};

export default getOperationMarkingById;
